<template>
  <!-- 新增运单跟踪-->
  <div class="container" >

    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList" style="width: 500px; ">
      <div class="glo_btnList_left">
        <div ref="queryForm">
          <el-form :model="queryData" :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'" label-position="left">
            <el-form-item class="queryItems" label="运单号:">
              <el-input clearable v-model="queryData.waybillNumber" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <queryBtns @clerBtns="clerBtns" @queryBtn_ok="queryBtn_ok" ></queryBtns>
    </div>

        <div style="height: 30px; width: 100%; border-top: 1px solid #ddd;"></div>
      <!-- 左边 -->
      <div class="rightInner">
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in TrackList"
            :key="index"
            :timestamp="item.title"
            placement="top"
            :color="item.color"
          >
            <el-card>
              <div class="card_class">
                <div class="line_cont">
                  <aside>{{ item.content }}</aside>
                  <div class="displayFlex">
                    <div v-if="item.expandFieldOne">
                      车牌号：{{ item.expandFieldOne || "" }}。
                    </div>
                    <div v-if="item.expandFieldTwo">
                      发出仓库：{{ item.expandFieldTwo || "" }}，
                    </div>
                    <div v-if="item.expandFieldThree">
                      目的地：{{ item.expandFieldThree || "" }}
                    </div>
                  </div>
                  <div class="trackImgsList">
                    <el-image
                      v-for="(itemA, idxA) in item.fileVoList"
                      :key="idxA"
                      class="trackImgs"
                      :src="itemA.fileUrl"
                      :preview-src-list="item.imgsList"
                    ></el-image>
                  </div>
                  <!-- <section>{{ item.createTime }}</section> -->
                  <section>{{ item.happenTime }}</section>
                </div>
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div
          class="nodata"
          v-if="TrackList.length == 0"
        >暂无运单轨迹</div>
      </div>
      <!-- 右边 -->

    </div>
</template>
<script>
import uploadimgs from '@/components/upLoadImgs.vue'
import multitime from "@/components/multiTime.vue";
import queryBtns from "@/components/queryBtns.vue";
export default {
  inject: ['reload'],
  components: {queryBtns, multitime, uploadimgs },
  data() {
    return {

      TrackList: [],
      //  -----  查询  ------
      queryData: {
        waybillNumber: "",
      }, //  表单查询数据
      isHaseMore: false, //false == 更多条件  true ==收起条件
    }
  },
  watch: {},
  created() {},
  mounted() {
    // 根据对象类型获取结算对象的下拉列表
    // this.getObjectUserDownList("employee"); //获取员工列表
    // this.getObjectUserDownList("dept"); //获取部门列表

  },
  activated() {
    let pageType = this.$route.query.pageType || '' //isTabs==tab切换的页面,不刷新页面
    let isreloads = this.$route.query.isreload //关闭页面的标记,关闭tab,不刷新页面
    if (pageType == 'isTabs' || isreloads == 'isreload') {
      return false
    } else {
      this.init()
    }
  },
  destroyed() {},
  methods: {
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      console.log("查询")
      this.getData();
    },
    changeisShow({ isShow, trackTransportId }) {
      this.$API
        .updateTrackTransportShow({
          isShow: isShow ? 1 : 0,
          trackTransportIds: [trackTransportId],
        })
        .then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.getData()
        })
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        waybillNumber: "",
      };
    },
    // 点击左边
    clickItems(item) {},
    init() {
      this.fileNameLists = []
      this.fileNameLists2 = []

      this.fetTableHeight()
      this.getData()
      // let { outboundCarrierId, outboundCarrierName, number } =
      //   this.$route.query || {};
      // this.addReqs.documentNumber = number || "";
      // this.outboundCarrierName = outboundCarrierName || "";
      // if (outboundCarrierId) {
      //   this.$COMAPI.CarrierDeptList(outboundCarrierId).then((res) => {
      //     this.CarrierDeptListList = res || [];
      //   });
      // }
    },
    getData() {
      console.log("进入查询")
      this.waybillNumber = this.queryData.waybillNumber || ''


      if (this.waybillNumber) {
        console.log("进入运单查询")
        let param = JSON.parse(JSON.stringify(this.queryData));
        console.log("param",param)
        this.$API
            .getTrackTransportListByWaybillNumber(param)
            .then((res) => {
              let arrs = res.data.result || []
              // .reverse()
              let TrackList = arrs //翻转数组
              TrackList.forEach((item, index) => {
                item.isShow = item.isShow == 1 ? true : false
                item.color = ''
                if (index == 0) {
                  item.color = '#0bbd87'
                }
                item.imgsList = []
                if (item.fileVoList && item.fileVoList.length > 0) {
                  item.fileVoList.forEach((itemA) => {
                    item.imgsList.push(itemA.fileUrl)
                  })
                }
              })

              this.TrackList = TrackList
            })
      }else {
        this.TrackList = [];
      }
    },

    clickReturnList() {
      this.$TOOLS.closePage()
      this.$router.push({
        path: '/WaybillManage/TrackingWaybill',
        query: {
          isreload: 'isreload',
        },
      })
    },

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    // 选择图片
    changeFileList2(array) {
      this.fileNameLists2 = array
    },
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let pagsHeigth = 40 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //
      this.$nextTick(() => {
        this.tableHeigth = tabHeight
      })
    },
  },
}
</script>
<style scoped lang="less">
.lookImgs {
  color: mediumblue;
  margin: 6px 0;
}
.trackImgsList {
  display: flex;
  flex-wrap: wrap;

  .trackImgs {
    width: 60px;
    height: 60px;
    margin: 10px;
  }
}
.topBtns {
  width: calc(100% - 270px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin: 0 30px;
  height: 50px;
}

.contentInner {
  width: 100%;
  display: flex;

  .rightInner {
    flex: 1;
    margin-right: 16px;
    cursor: pointer;
    overflow-y: auto;
    border: 1px solid #ddd;
    padding: 10px;
  }

  .leftInner {
    flex: 1;
    /deep/ .el-tabs__item {
      height: 36px;
      line-height: 36px;
      background-color: #f4f4f4;
    }

    /deep/ .el-tabs__content {
      padding: 16px;
    }

    /deep/ .el-descriptions {
      margin-bottom: 10px;
    }
  }
}
/deep/.el-timeline-item__timestamp {
  font-size: 16px;
  color: #333;
}
.line_cont {
  color: #888;
}
.tit_top {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
  span {
    flex: 1;
  }
}
// 查询条件边框线
.infoDiv {
  margin-bottom: 20px;

  .formbox {
    padding: 0 30px;
  }
}
.textArea {
  height: 100%;
}

.displayFlex {
  display: flex;
}

.nodata {
  width: 100%;
  text-align: center;
  margin-top: 40vh;
  color: #999;
}
.card_class {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.formbox {
  padding: 10px 30px 30px;

  .jsInput {
    .jsBtns {
      height: 30px;
      line-height: 30px;
      margin: 0;
      padding: 0 10px;
      border: none;
    }
  }

  .formBtns {
    height: 33px;
    margin: 0;
    padding: 0 10px;
  }

  .checkBoxStyle {
    width: 23%;
    min-width: 260px;
    margin-bottom: 10px;

    display: flex;
    align-items: center;
  }
}

.signClass {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.uploadBox {
  width: 100%;
  display: flex;
  align-items: center;

  .uploadItem {
    flex: 1;

    .uploadLaber {
      margin-bottom: 10px;
    }
  }
}
</style>
